import { Link } from "react-router-dom";
import { Truck, Package, Sparkles, Warehouse, ArrowRight } from "lucide-react";
import SEO from "@/components/SEO";
import { FadeUp, MaskLine } from "@/components/motion";
import { SERVICES } from "@/data/content";

const ICONS = { Truck, Package, Sparkles, Warehouse };

export default function Services() {
  return (
    <main className="pt-20">
      <SEO
        title="Moving, Packing, Cleaning & Storage Services"
        description="Comprehensive moving solutions: local house removals, packing services, end of lease cleaning, and secure container storage across Australia."
        path="/services"
      />
      <section className="bg-navy grain py-16 sm:py-24">
        <div className="mx-auto max-w-7xl px-4 sm:px-8">
          <p className="text-xs font-mono uppercase tracking-[0.22em] font-semibold text-amber-500">Services</p>
          <h1 className="mt-4 font-display text-4xl sm:text-5xl lg:text-6xl font-black tracking-tight leading-[1.08] text-white">
            <MaskLine delay={0.1}>Everything your move needs,</MaskLine>
            <MaskLine delay={0.22}><span className="text-amber-400">under one roof.</span></MaskLine>
          </h1>
        </div>
      </section>

      <section className="mx-auto max-w-7xl px-4 sm:px-8 py-16 sm:py-24 grid gap-8 md:grid-cols-2">
        {SERVICES.map((s, i) => {
          const Icon = ICONS[s.icon];
          return (
            <FadeUp key={s.slug} delay={i * 0.08}>
              <Link to={`/services/${s.slug}`} data-testid={`services-card-${s.slug}`}
                className="card-lift group block h-full overflow-hidden rounded-2xl border border-slate-200 bg-white">
                <div className="relative h-52 overflow-hidden">
                  <img src={s.image} alt={s.imageAlt} className="h-full w-full object-cover transition-transform duration-500 group-hover:scale-105" />
                  <span className="absolute left-5 top-5 flex h-11 w-11 items-center justify-center rounded-xl bg-navy text-amber-400">
                    <Icon className="h-5 w-5" />
                  </span>
                </div>
                <div className="p-8">
                  <h2 className="font-display text-xl sm:text-2xl font-bold tracking-tight text-navy">{s.title}</h2>
                  <p className="mt-2 text-sm sm:text-base text-slate-600">{s.tagline}</p>
                  <span className="mt-6 inline-flex items-center gap-1 text-sm font-bold text-amber-600">
                    Learn more <ArrowRight className="h-4 w-4 transition-transform duration-200 group-hover:translate-x-1" />
                  </span>
                </div>
              </Link>
            </FadeUp>
          );
        })}
      </section>
    </main>
  );
}
